import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AboutPage from "../pages/about/page";
import SessionPage from "../pages/session/page";
import PricePage from "../pages/price/page";
import SchedulePage from "../pages/schedule/page";
import HowToBookPage from "../pages/how-to-book/page";
import GalleryPage from "../pages/gallery/page";
import VideoPage from "../pages/video/page";
import ReviewsPage from "../pages/reviews/page";
import BlogPage from "../pages/blog/page";
import ContactPage from "../pages/contact/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/session", element: <SessionPage /> },
  { path: "/price", element: <PricePage /> },
  { path: "/schedule", element: <SchedulePage /> },
  { path: "/how-to-book", element: <HowToBookPage /> },
  { path: "/gallery", element: <GalleryPage /> },
  { path: "/video", element: <VideoPage /> },
  { path: "/reviews", element: <ReviewsPage /> },
  { path: "/blog", element: <BlogPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
